"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
// import app components
const registerForm_1 = __importDefault(require("../../combinations/registerForm"));
const authTemplate_1 = __importDefault(require("../../combinations/authTemplate"));
const Register = (props) => {
    const { quote, authorOrRole, description, backgroundImage, message, component = "registerForm", loading, linkComponent, loginLink, registerLink, termsLink, privacyPolicyLink, onSubmit, email, } = props;
    const renderComponent = () => {
        switch (component) {
            case "registerForm":
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(material_1.Stack, null,
                        react_1.default.createElement(registerForm_1.default, { onSubmit: onSubmit, loading: loading, termsLink: termsLink, privacyPolicyLink: privacyPolicyLink }))));
            case "successfulRegistration":
                return (react_1.default.createElement(material_1.Alert, { severity: "success" },
                    "We sent an email to ",
                    email,
                    ". Click the link inside to activate your account. Check your spam folder if you haven't gotten it yet!"));
        }
    };
    return (react_1.default.createElement(authTemplate_1.default, { quote: quote, authorOrRole: authorOrRole, description: description, backgroundImage: backgroundImage, message: message, highlightRegister: true, linkComponent: linkComponent, loginLink: loginLink, registerLink: registerLink }, renderComponent()));
};
exports.default = Register;
